export const getEngineStatusDisplayValue =(engineStatus)=>{
  return engineStatus === "ENGINE_OFF"
    ? "OFF"
    : engineStatus === "ENGINE_ON"
    ? "ON"
    : engineStatus;
}